<template lang="pug">
  .browsable-product-line.container(:id="options.id")
    .row.xs-f-small.md-f-medium.lg-f-small.max-at-tweak
      .fixed-width-tweak-upper
        .padded-wrap
          .top-wrap.xs-12.text-center
            h2.upper.bold.semi-wide-letter-spacing.xs-f-xmedium.sm-f-large.md-f-xlarge.lg-f-large.max-at-tweak(v-if="options.titleH2") {{ options.titleH2 }}
            p.xs-f-small.sm-f-small.md-f-medium.max-at-tweak(v-if="options.text") {{ options.text }}

          .products-wrap.xs-12(v-if="!options.hideCta && options.cta && !lightWorks")
            .find-wrap.xs-12.lg-3.text-center
              .a-box-xs-7x2.a-box-sm-4x1.a-box-lg-1x1
                .a-box-content
                  .v-center.full-width
                    p.upper.semi-wide-letter-spacing.xs-f-xsmall.sm-f-small.md-f-medium.lg-f-small.max-at-tweak Not sure of your shade?
                    a.upper.underline.bold.semi-wide-letter-spacing.xs-f-xsmall.sm-f-small.md-f-medium.lg-f-small.max-at-tweak(:href='bestMatch') {{options.cta.text}}

            a.product-wrap.xs-6.lg-3.text-center.text-color-1(v-for="product in products" :href="product.uri" v-if="product && product.status && product.visible")
              img.full-width(:src="product.imagery.alternative.url" :alt="product.imagery.alternative.alt_text")
              p.prod-name.upper.bold.semi-wide-letter-spacing.xs-f-small.md-f-medium.lg-f-small.max-at-tweak {{ product.name }}
              p.xs-f-small.md-f-medium.lg-f-small.max-at-tweak {{ product.short_description }}
              stars.xs-f-medium.md-f-xmedium.lg-f-medium.max-at-tweak(:product-id="product.id")

          .products-wrap-lw.xs-12.text-center(v-if="lightWorks")
            .light-products.xs-12.sm-12.md-4
              p.products-title.color-slate.xs-f-medium.lg-f-xmedium.max-at-tweak For medium brown to blonde hair:
              a.product-wrap-lw.text-center.color-black(v-for="product in products" v-if="product.lightOrDark == 'light' && product.status && product.visible && shortOrLong(product)" :href="productUrl(product)")
                .image-wrap.full-width
                  img.full-width(:src="product.imagery.squareSwatch.url" :alt="product.imagery.squareSwatch.alt_text")
                  img.before-swatch(:src="product.imagery.roundSwatch.url" :alt="product.imagery.roundSwatch.alt_text")
                p.prod-name.upper.bold.xs-f-small.max-at-tweak {{product.name}}

            .dark-products.xs-12.sm-12.md-4
              p.products-title.color-slate.xs-f-medium.lg-f-xmedium.max-at-tweak For dark brown to medium brown hair:
              a.product-wrap-lw.text-center.color-black(v-for="product in products" v-if="product.lightOrDark == 'dark' && product.status && product.visible && shortOrLong(product)" :href="productUrl(product)")
                .image-wrap.full-width
                  img.full-width(:src="product.imagery.squareSwatch.url" :alt="product.imagery.squareSwatch.alt_text")
                  img.before-swatch(:src="product.imagery.roundSwatch.url" :alt="product.imagery.roundSwatch.alt_text")
                p.prod-name.upper.bold.xs-f-small.max-at-tweak {{product.name}}


</template>

<script>
  import { getProductsByType } from '@services/vueProductSvc';
  import bestMatchMixin from '@mixins/bestMatchMixin';

  export default {
    name: 'BrowsableProductLine',

    mixins: [bestMatchMixin],

    props: {
      options: {
        type: Object,
        default: () => ({}),
      }
    },

    data: () => ({
      products: []
    }),

    computed: {
      bestMatch() {
        return this.mix_bestMatchUrl('root_reboot', this.options.cta);
      },

      lightWorks() {
        return this.options.productType == "light_works";
      },
    },

    mounted() {
      getProductsByType({productType: this.options.productType}).then((res) => {
        return this.products = res.data;
      });
    },

    methods: {
      shortOrLong(p) {
        // If customer has short hair and product is short hair show it
        if (p.shortHair && this.cdata.beautyProfile.hair_length == 'short') {
          return true;
          // if customer is not short hair only show normal length products
        } else if (!p.shortHair && this.cdata.beautyProfile.hair_length != "short") {
          return true;
        }
      },
      productUrl(p) {
        return `/product/${p.url_key}`;
      }
    }
  };
</script>

<style lang="stylus">
  .browsable-product-line
    .row
      padding 2em 0

    .padded-wrap
      padding 0 4%

    .top-wrap
      padding-bottom 2em

    .find-wrap
      padding 0 1%

      .a-box-content
        border 0.6125em solid brand-color-2

      .v-center
        padding 0 10%

        p
          padding-bottom 0.25em

    .product-wrap
      padding 0 1%
      min-height 25em

      &:hover
        color black

    .products-wrap-lw
      padding 0 1.25em

      .products-title
        padding-bottom 1em

      .light-products
      .dark-products
        width initial

        .product-wrap-lw
          max-width 11.5em
          min-height 18em
          padding 1em

      .light-products
        margin-right 2em

      .product-wrap-lw
        display inline-block
        vertical-align top
        width 50%
        padding 0 1.25em
        min-height 22em

        &:hover
          color black

        .image-wrap
          position relative
          margin-bottom 1.25em

          img
            vertical-align middle

          .before-swatch
            position absolute
            right -1.25em
            bottom -1.25em
            border-radius 50%
            border 2px solid color-white
            width 6.25em

        .prod-name
          padding-top 0.5em

    @media mq-mobile
      .find-wrap
        padding 0 2%
        margin-bottom 2em

        .v-center
          padding 0 5%

          p
            padding-bottom 0

      .product-wrap
        padding 0 2%
        min-height 23em

      .products-wrap-lw
        padding 0 0.75em

        .light-products
        .dark-products
          width 100%

          .product-wrap-lw
            padding 0 0.75em
            min-height 16em

            .image-wrap
              margin-bottom 0.75em

              .before-swatch
                width 5em
                right -0.75em
                bottom -0.75em

        .dark-products
          padding-top 0

    @media mq-tablet
      .padded-wrap
        padding 0 5%

      .products-wrap
        padding 0 5%

      .find-wrap
        padding 0 2.5%
        margin-bottom 2em

        .v-center
          padding 0 5%

          p
            padding-bottom 0

      .product-wrap
        padding 0 2.5%
        min-height 24em

      .products-wrap-lw
        padding 0 12%

        .product-wrap-lw
          min-height 20em

        .light-products
          width 100%
          margin-right 2em

        .dark-products
          padding-top 0
          width 100%

    @media mq-desktop-md
      .padded-wrap
        padding 0 10%

        .products-wrap-lw
          padding 0 12%

          .light-products
          .dark-products
            width 100%
            text-align center

            .product-wrap-lw
              min-height 16em
              width 33%
              padding 1em

          .dark-products
            padding-top 0.5em

          .light-products
            margin-right 2em

      .products-wrap
        padding 0 5%

      .find-wrap
        padding 0 2.5%
        margin-bottom 2em

        .v-center
          padding 0 5%

          p
            padding-bottom 0

      .product-wrap
        padding 0 2.5%
        min-height 24em


</style>
